import { defineMessages } from 'react-intl';

import { TECHNICAL_INTERVENTION_STATUS } from '@savgroup-front-common/types';

export default defineMessages({
  [TECHNICAL_INTERVENTION_STATUS.SCHEDULED]: {
    id: 'technicalIntervention.type.scheduled',
    defaultMessage: 'Scheduled',
  },
  [TECHNICAL_INTERVENTION_STATUS.PLANNED]: {
    id: 'technicalIntervention.type.planned',
    defaultMessage: 'Planned',
  },
  [TECHNICAL_INTERVENTION_STATUS.NONE]: {
    id: 'technicalIntervention.status.none',
    defaultMessage: 'None',
  },
  [TECHNICAL_INTERVENTION_STATUS.PLANNING_COMMENT]: {
    id: 'technicalIntervention.status.planning_comment',
    defaultMessage: 'Planning Comment',
  },
  [TECHNICAL_INTERVENTION_STATUS.DISPATCHED]: {
    id: 'technicalIntervention.status.dispatched',
    defaultMessage: 'Dispatched',
  },
  [TECHNICAL_INTERVENTION_STATUS.IN_PROGRESS]: {
    id: 'technicalIntervention.status.in_progress',
    defaultMessage: 'In Progress',
  },
  [TECHNICAL_INTERVENTION_STATUS.COMPLETED]: {
    id: 'technicalIntervention.status.completed',
    defaultMessage: 'Completed',
  },
  [TECHNICAL_INTERVENTION_STATUS.FINISHED]: {
    id: 'technicalIntervention.status.finished',
    defaultMessage: 'Finished',
  },
  [TECHNICAL_INTERVENTION_STATUS.CANNOT_COMPLETE]: {
    id: 'technicalIntervention.status.cannot_complete',
    defaultMessage: 'Cannot Complete',
  },
  [TECHNICAL_INTERVENTION_STATUS.CANCELED]: {
    id: 'technicalIntervention.status.canceled',
    defaultMessage: 'Canceled',
  },
  [TECHNICAL_INTERVENTION_STATUS.NEW]: {
    id: 'technicalIntervention.status.new',
    defaultMessage: 'New',
  },
  [TECHNICAL_INTERVENTION_STATUS.ASSIGNED]: {
    id: 'technicalIntervention.status.assigned',
    defaultMessage: 'Assigned',
  },
  [TECHNICAL_INTERVENTION_STATUS.ON_THE_WAY]: {
    id: 'technicalIntervention.status.on_the_way',
    defaultMessage: 'On the Way',
  },
  [TECHNICAL_INTERVENTION_STATUS.REPAIRED]: {
    id: 'technicalIntervention.status.repaired',
    defaultMessage: 'Repaired',
  },
  [TECHNICAL_INTERVENTION_STATUS.REPAIR_REFUSED_BY_CUSTOMER]: {
    id: 'technicalIntervention.status.repair_refused_by_customer',
    defaultMessage: 'Repair Refused by Customer',
  },
  [TECHNICAL_INTERVENTION_STATUS.QUOTE_TO_BE_ISSUED]: {
    id: 'technicalIntervention.status.quote_to_be_issued',
    defaultMessage: 'Quote to be Issued',
  },
  [TECHNICAL_INTERVENTION_STATUS.QUOTE_ISSUED]: {
    id: 'technicalIntervention.status.quote_issued',
    defaultMessage: 'Quote Issued',
  },
  [TECHNICAL_INTERVENTION_STATUS.SPARE_PART_REQUEST_TO_BE_MADE]: {
    id: 'technicalIntervention.status.spare_part_request_to_be_made',
    defaultMessage: 'Spare Part Request to be Made',
  },
  [TECHNICAL_INTERVENTION_STATUS.SPARE_PART_REQUEST_DONE]: {
    id: 'technicalIntervention.status.spare_part_request_done',
    defaultMessage: 'Spare Part Request Done',
  },
  [TECHNICAL_INTERVENTION_STATUS.IN_TESTING]: {
    id: 'technicalIntervention.status.in_testing',
    defaultMessage: 'In Testing',
  },
  [TECHNICAL_INTERVENTION_STATUS.RECORDER_DEPOSIT_REQUEST]: {
    id: 'technicalIntervention.status.recorder_deposit_request',
    defaultMessage: 'Recorder Deposit Request',
  },
  [TECHNICAL_INTERVENTION_STATUS.RECORDER_DEPOSIT_DONE]: {
    id: 'technicalIntervention.status.recorder_deposit_done',
    defaultMessage: 'Recorder Deposit Done',
  },
  [TECHNICAL_INTERVENTION_STATUS.TECHNICALLY_IRREPARABLE]: {
    id: 'technicalIntervention.status.technically_irreparable',
    defaultMessage: 'Technically Irreparable',
  },
  [TECHNICAL_INTERVENTION_STATUS.ECONOMICALLY_IRREPARABLE]: {
    id: 'technicalIntervention.status.economically_irreparable',
    defaultMessage: 'Economically Irreparable',
  },
  [TECHNICAL_INTERVENTION_STATUS.WAITING_FOR_ADDITIONAL_INFORMATION]: {
    id: 'technicalIntervention.status.waiting_for_additional_information',
    defaultMessage: 'Waiting for Additional Information',
  },
  [TECHNICAL_INTERVENTION_STATUS.WORKSHOP_RETURN_REQUESTED]: {
    id: 'technicalIntervention.status.workshop_return_requested',
    defaultMessage: 'Workshop Return Requested',
  },
  [TECHNICAL_INTERVENTION_STATUS.WORKSHOP_RETURN_DONE]: {
    id: 'technicalIntervention.status.workshop_return_done',
    defaultMessage: 'Workshop Return Done',
  },
  [TECHNICAL_INTERVENTION_STATUS.LOAN_DEPOSIT_REQUESTED]: {
    id: 'technicalIntervention.status.loan_deposit_requested',
    defaultMessage: 'Loan Deposit Requested',
  },
  [TECHNICAL_INTERVENTION_STATUS.NEW_APPOINTMENT_TO_BE_SCHEDULED]: {
    id: 'technicalIntervention.status.new_appointment_to_be_scheduled',
    defaultMessage: 'New Appointment to be Scheduled',
  },
  [TECHNICAL_INTERVENTION_STATUS.CUSTOMER_ABSENT]: {
    id: 'technicalIntervention.status.customer_absent',
    defaultMessage: 'Customer Absent',
  },
  [TECHNICAL_INTERVENTION_STATUS.INTERVENTION_REFUSED_BY_CUSTOMER]: {
    id: 'technicalIntervention.status.intervention_refused_by_customer',
    defaultMessage: 'Intervention Refused by Customer',
  },
  [TECHNICAL_INTERVENTION_STATUS.WRONG_CUSTOMER_ADDRESS]: {
    id: 'technicalIntervention.status.wrong_customer_address',
    defaultMessage: 'Wrong Customer Address',
  },
  [TECHNICAL_INTERVENTION_STATUS.SPARE_PART_ISSUE]: {
    id: 'technicalIntervention.status.spare_part_issue',
    defaultMessage: 'Spare Part Issue',
  },
  [TECHNICAL_INTERVENTION_STATUS.INACCESSIBLE_PRODUCT]: {
    id: 'technicalIntervention.status.inaccessible_product',
    defaultMessage: 'Inaccessible Product',
  },
  [TECHNICAL_INTERVENTION_STATUS.TECHNICIAN_UNFORESEEN]: {
    id: 'technicalIntervention.status.technician_unforeseen',
    defaultMessage: 'Technician Unforeseen',
  },
});
